/**
 * Skills Tutor material status constants
 * Note: These values must match the backend API expectations exactly
 */
export const SKILLS_TUTOR_STATUS = {
  ASSIGNED: 'assigned',
  UNASSIGNED: 'Unassigned',
} as const

export type SkillsTutorStatus = typeof SKILLS_TUTOR_STATUS[keyof typeof SKILLS_TUTOR_STATUS]
